var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Left" },
    _vm._l(_vm.leftPoint, function (item, index) {
      return _c(
        "div",
        {
          key: index,
          class:
            item.path === _vm.$route.name
              ? "Left-Point Left-Point-active"
              : "Left-Point",
          on: {
            click: function ($event) {
              return _vm.activePoint(item, index)
            },
          },
        },
        [
          item.path === _vm.$route.name
            ? _c("img", { attrs: { src: item.active, alt: "" } })
            : _c("img", { attrs: { src: item.noActive, alt: "" } }),
          _c("span", [_vm._v(_vm._s(item.name))]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }